import type {
  ImageFlavour,
  PackageImage,
  PublicPackageCustomer,
  PublicPackageListItem,
  PublicPackageListResponse,
  PublicPackageResponse,
} from "@przezmorze/api-types";
import { przezmorzeApi } from "../../api/api";

export type { ImageFlavour };
export type { PackageImage as PackageImageDTO };
export type { PublicPackageListItem as ListPublicPackagesResponseItem };
export type { PublicPackageCustomer as PackageCustomerResponse };
export type { PublicPackageResponse };

export async function listPublicPackages(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<PublicPackageListResponse>("/public/packages", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function listAlternativePackages(packageId: string, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<PublicPackageListItem[]>(`/public/packages/${packageId}/alternative`, {
    signal: abortSignal,
  });
  return response.data;
}

export async function getPublicPackage(packageId: string, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<PublicPackageResponse>(`/public/packages/${packageId}`, {
    signal: abortSignal,
  });
  return response.data;
}
